import React, { useLayoutEffect, forwardRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useDarkMode from '../../hooks/useDarkMode';
import apiServicewt from '../../api/apiServicewt';
import { useLoginSettings } from '../../contexts/loginSettingsContext';

const PageWrapper = forwardRef(({ title, description, className, children }, ref) => {
	const { themeStatus } = useDarkMode();
	const { loginSettings } = useLoginSettings();

	useLayoutEffect(() => {
		document.getElementsByTagName('TITLE')[0].text = `${title ? `${title} | ` : ''}${
			loginSettings.company_name || 'Schedulerdesk'
		}`;
		document
			.querySelector('meta[name="description"]')
			.setAttribute('content', description || process.env.REACT_APP_META_DESC);
	});

	return (
		<div
			ref={ref}
			style={{
				backgroundColor:
					themeStatus === 'light' && title !== 'Login' && title !== 'Sign Up'
						? '#ececec'
						: undefined,
			}}
			className={classNames('page-wrapper', 'container-fluid', className)}>
			{children}
		</div>
	);
});
PageWrapper.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};
PageWrapper.defaultProps = {
	title: null,
	description: null,
	className: null,
};

export default PageWrapper;
